<template>
  <div class="news">
    <div class="name">新闻动态</div>
    <div class="border"></div>
    <!--        <div class="lable">专注于区块链行业 自主研发技术领先</div>-->
    <div class="content">
      <el-carousel :interval="5000" height="420px" indicator-position="outside">
        <el-carousel-item v-for="(item,index) in newsList" :key="index">
          <div
              class="new"
              v-for="(items,indexs) in item" :key="indexs">
            <img :src="items.img" alt="">
            <div class="new-text">
              <div class="new-title">{{items.title}}</div>
              <div class="new-lable">{{items.design}}</div>
            </div>
            <div class="time">
              {{items.publishDate.slice(0,10)}}
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "home-new",
  data() {
    return {
      newsList: [],
    };
  },
  mounted() {
    this.getNewsList();
  },
  methods: {
    getNewsList() {
      axios
        .post(
          "https://article.trilliontrust.com/publish-article/app/article/zhaowulist ",
          {
            page: "1",
            limit: "12",
          }
        )
        .then(({ data }) => {
          // this.newsList = data.page.list;
          this.$set(this.newsList, 0, []);
          this.$set(this.newsList, 1, []);
          this.$set(this.newsList, 2, []);
          for (let n = 0; n < data.page.list.length; n++) {
            if (n < 3) {
              this.newsList[0].push(data.page.list[n]);
            } else if (n < 6) {
              this.newsList[1].push(data.page.list[n]);
            } else if (n < 9) {
              this.newsList[2].push(data.page.list[n]);
            }
          }
          console.log(this.newsList);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped lang="scss">
.news{
  margin: 0 auto;
  max-width: 1280px;
  text-align: center;
  padding-top: 40px;
  .name {
    height: 45px;
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 900;
    color: #21242A;
    line-height: 45px;
  }
  .border {
    margin: 20px auto;
    width: 27px;
    height: 3px;
    background-color: #056DFF;
  }
  .lable {
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #7c7878;
    line-height: 20px;
    margin-bottom: 50px;
  }
  .content{
    margin: 40px auto 0 auto;
    width: 100%;
    /deep/.el-carousel__indicators--horizontal {
      /*position: absolute;*/
      /*left: auto;*/
      /*right: 10px;*/
      /*bottom: 10px;*/
      /*text-align: right;*/

      .el-carousel__indicator--horizontal button {
        width: 10px;
        height: 8px;
        background: #DAE2E6;
        border-radius: 30%;
        opacity: 0.5;
      }

      .el-carousel__indicator--horizontal.is-active button {
        width: 24px;
        height: 8px;
        background: #055EFF;
        opacity: 0.5;
        border-radius: 10px;
      }
    }
    .new{
      background-color: #FAFBFC;
      height: 130px;
      margin-bottom: 10px;
      display: flex;
      justify-content:space-between;
      align-items: center;
      padding-left: 19px;
      padding-right: 25px;
      cursor: pointer;
      img{
        width: 187px;
        height: 95px;
      }
      .new-text{
        text-align: left;
        width: 700px;
        .new-title{
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 700;
          color: #282F3C;
          line-height: 25px;
          overflow:hidden;
          white-space:nowrap;
          text-overflow:ellipsis;
        }
        .new-lable{
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #646C7C;
          line-height: 22px;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          margin-top: 10px;
        }
      }
      .time{
        height: 85px;
        font-size: 18px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 300;
        color: #B8BFC6;
        border-left: 1px solid #E5E8EA;
        line-height:85px;
        padding-left: 20px;
      }
    }
  }
}
</style>
